import { HttpClient, HttpEvent, HttpEventType } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Helper } from 'app/common/helper';
import { Constant } from 'app/config/constants';
import { CommonService } from 'app/service/common.service';
import { DialogService } from 'app/service/dialog.service';
import moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { Route } from '../../model/entity/route';
import { DialogMessageComponent } from '../dialog-message/dialog-message.component';

@Component({
  selector: 'app-dialog-publish-data',
  templateUrl: './dialog-publish-data.component-bus-information.html',
  styleUrls: ['./dialog-publish-data.component-bus-information.scss']
})
export class DialogPublishDataBusInformationComponent implements OnInit {
  /**
   * title
   */
  title: string = 'Publish';
  /**
   * description
   */
  description: string = '';
  /**
   * list route
   */
  routes: Array<Route>;
  /**
   * date from
   */
  dateFrom: Date;
  /**
   * time zone
   */
  timeZone = Constant.TIME_ZONE_DEFAULT;
  /**
   *
   */
  progress: number = 0;

  /**
   * loading publish
   */
  loading: boolean;
  /**
   * setting data
   */
  setting: any;

  constructor(
    public dialogRef: MatDialogRef<DialogPublishDataBusInformationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private http: HttpClient,
    private toast: ToastrService,
    private dialogService: DialogService,
    private commonService: CommonService
  ) {
    this.routes = this.data.routes;
    this.dateFrom = new Date();
    this.description = moment(this.dateFrom).format('MMM. DD, YYYY');
    this.loading = false;
  }

  ngOnInit(): void {
    this.progress = 0;
    this.setting = this.commonService.getCommonObject().setting;
    if (this.setting) {
      this.timeZone = this.setting.timezone.name;
    }
  }

  closeDialog() {
    this.dialogRef.close();
  }

  /**
   * set start date
   * @param event event
   */
  setStartDate(event) {
    this.dateFrom = new Date(event.target.value);
  }

  publish() {
    if (this.description.length > 256) {
      this.dialogService.showDialog(DialogMessageComponent, {
        data: { title: 'Error', text: 'Description cannot be longer than 256 characters.' }
      });
      return;
    }

    let dataSetting = this.commonService.getInfoPublish();
    dataSetting.routesId = this.routes.map(route => route.id);
    let GMTTimeZone = Helper.getUserTimeZone(this.commonService.getCommonObject().setting);
    dataSetting.validFrom = Helper.convertDateToString(this.dateFrom) + 'T00:00:00' + GMTTimeZone;
    dataSetting.description = this.description;

    if (!dataSetting.projectName) {
      this.dialogService.showDialog(DialogMessageComponent, { data: { title: 'Error', text: 'Please select a project.' } });
      return;
    }
    this.loading = true;
    this.http
      .post(Constant.BACKEND_URL + Constant.PUBLISH_SERVICE_URL + 'api/publish/bid', dataSetting, {
        reportProgress: true,
        observe: 'events'
      })
      .subscribe(
        (event: HttpEvent<any>) => {
          switch (event.type) {
            case HttpEventType.Sent:
              console.log('Request has been made!');
              break;
            case HttpEventType.ResponseHeader:
              console.log('Response header has been received!');
              break;
            case HttpEventType.UploadProgress:
              break;
            case HttpEventType.Response:
              console.log('Request succeeded!');
              this.progress = 100;
              this.loading = false;
              setTimeout(() => {
                this.toast.success('Publish successfully.', '');
                this.closeDialog();
              }, 1000);
          }
        },
        error => {
          this.dialogRef.close();
          this.dialogService.showDialog(DialogMessageComponent, {
            data: {
              title: `Error`,
              text: `An error has occurred. Please try again.`
            }
          });
        }
      );
  }
}

export interface DialogData {
  routes: Array<Route>;
}
